import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import React, { useEffect, useMemo, useState } from "react";

import { DatePicker } from "antd";
import Flatpickr from "react-flatpickr";
import LinePack from "./tab/LinePack";
import { Link } from "react-router-dom";
import Offshore from "./tab/Offshore";
import Onshore from "./tab/Onshore";
import classnames from "classnames";
import moment from "moment";

//i18n

function GasVolumeLinePack(props) {
  const [activeTab, setActiveTab] = useState("1");
  const [dateSelected, setDateSelected] = useState(
    moment().add(-1, "day").toDate()
  );
  const [pageDataConfirmModal, dataConfirmModal] = useState(false);
  function disabledDate(current) {
    // Can not select days before today and today
    return current && current > moment().add(-1,"day").endOf("day");
  }

  //onInit//
  useEffect(function () {}, []);
  //onInit//
  const TabBar = useMemo(() => {
    return (
      <>
        <TabPane tabId="1">
          <Offshore dateSelected={dateSelected} />
        </TabPane>

        <TabPane tabId="2">
          <Onshore dateSelected={dateSelected} />
        </TabPane>

        <TabPane tabId="3">
          <LinePack dateSelected={dateSelected} />
        </TabPane>
      </>
    );
  }, [dateSelected]);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              {/* <Card>
                <CardBody>
                  
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h1 className="mb-sm-0 font-size-20">
                      Gas Volume & Line Pack
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Manual Data Entry
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Gas Volume & Line Pack
                        </li>
                      </ol>
                    </div>
                  </div>
                </CardBody>
              </Card> */}

              <Row>
                <Col sm="12">
                  <Card>
                    <CardBody>
                      <Row>
                        <Col sm="12">
                          <FormGroup className="row">
                            <div className=" d-flex align-items-center justify-content-end">
                              <h5> Data Month : </h5>
                              <DatePicker
                                style={{ width: 200, marginLeft: 20 }}
                                defaultValue={moment(dateSelected)}
                                format={"MMMM YYYY"}
                                onChange={(date, dateString) => {
                                  if (date != null) {
                                    setDateSelected(date.toDate());
                                  }
                                }}
                                picker="month"
                                disabledDate={disabledDate}
                              />
                            </div>
                            {/* <Col
                              sm={10}
                              className=" d-flex align-items-center justify-content-end"
                            ></Col>
                            <Col
                              sm={2}
                              className="d-flex align-items-center justify-content-start"
                            >
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                onChange={value => console.log(value)}
                                value={dateSelected}
                                options={{
                                  altInput: true,
                                  // altFormat: "d/m/Y",
                                  altFormat: "F Y",
                                  dateFormat: "d/m/Y",
                                  maxDate: new Date(),
                                }}
                              />
                            </Col> */}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <hr />
                      </Row>

                      <Row>
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "1",
                              })}
                              onClick={() => {
                                setActiveTab("1");
                                // dataConfirmModal(true);
                              }}
                            >
                              Offshore Gas Volume
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "2",
                              })}
                              onClick={() => {
                                setActiveTab("2");
                                // dataConfirmModal(true);
                              }}
                            >
                              Onshore Gas Volume
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "3",
                              })}
                              onClick={() => {
                                setActiveTab("3");
                                // dataConfirmModal(true);
                              }}
                            >
                              Line Pack
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Row>

                      <Row>
                        <TabContent
                          activeTab={activeTab}
                          className="p-3 text-muted"
                        >
                          {TabBar}
                        </TabContent>
                      </Row>

                      {/* <hr /> */}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>

            {/*start : DataConfirmModal */}
            <Modal size="lg" isOpen={pageDataConfirmModal}>
              <div className="modal-header">
                <h5 className="modal-title mt-0" id="myModalLabel">
                  Confirm
                </h5>
              </div>
              <div className="modal-body p-0">
                <CardBody className="p-3">
                  <Form>
                    <Row>
                      <div className="modal-body text-center p-0">
                        <h4>มีการเปลี่ยนข้อมูลในตาราง</h4>
                        <br />
                        <h4>คุณต้องการบันทึกการเปลี่ยนแปลงหรือไม่ ?</h4>
                      </div>
                    </Row>
                  </Form>
                </CardBody>
                <div className="modal-footer">
                  <button type="button" className="btn btn-success me-2">
                    <i className="fas fa-check"></i>&nbsp; Confirm
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => dataConfirmModal(false)}
                  >
                    <i className="fas fa-times fa-lg"></i>&nbsp; Cancel
                  </button>
                </div>
              </div>
            </Modal>
            {/*end : PageAdd */}
          </Row>
        </Container>
      </div>

      {/*end : PageAdd */}
    </React.Fragment>
  );
}
export default GasVolumeLinePack;
